<template>
  <div>
    <table class="table">
      <tr>
        <td colspan="2">用户ID：</td>
        <td>充豆类型：</td>
        <td>
          <el-select size="medium" v-model="form.rechargeType" @change="rechargeTypeChange">
            <el-option
              v-for="item of rechargeTypeOptions"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </td>
        <td>金豆类型：</td>
        <td>
          <el-select size="medium" v-model="form.chipType">
            <el-option
              v-for="item of chipTypeOptions"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </td>
      </tr>
      <tr>
        <td rowspan="3" colspan="2" style="padding-right: 30px">
          <el-input
            v-model="userRandomIds"
            type="textarea"
            size="medium"
            :rows="5"
            resize="none"
            placeholder="请输入用户ID，多个ID用英文逗号隔开"
          >
          </el-input>
        </td>
        <template v-if="form.rechargeType === 5">
          <td>补单订单号：</td>
          <td>
            <el-input placeholder="请输入" size="medium" v-model="form.replenishmentNo" />
          </td>
        </template>
        <template v-else>
          <td>充豆状态：</td>
          <td>
            <el-select
              :disabled="rechargeStatusDisabled"
              size="medium"
              v-model="form.rechargeStatus"
            >
              <el-option
                v-for="item of rechargeStatusOptions"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </td>
        </template>
        <td>申请人：</td>
        <td>
          <el-input placeholder="请输入" size="medium" v-model="form.applicant" />
        </td>
      </tr>
      <tr>
        <td>充豆数量：</td>
        <td style="padding-right: 30px">
          <el-input placeholder="请输入" size="medium" type="number" v-model="form.rechargeChip" />
        </td>
        <td>审批人：</td>
        <td>
          <el-input placeholder="请输入" size="medium" v-model="form.approver" />
        </td>
      </tr>
      <tr>
        <td colspan="2">最大数位提示：{{ form.rechargeChip | numberUnit }}</td>
        <td colspan="2" style="text-align: right">
          <el-button size="medium" type="primary" @click="showPopup">确定</el-button>
        </td>
      </tr>
    </table>
    <div v-show="show" class="common-popup-bg">
      <div class="common-popup">
        <h3>充豆</h3>
        <el-form
          ref="rechargeForm"
          :model="form"
          :rules="rules"
          class="common-popup-table"
          size="medium"
          label-width="110px"
        >
          <el-form-item label="谷歌验证码：" prop="smsCode">
            <el-input v-model="form.smsCode"> </el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input v-model="form.remark"></el-input>
          </el-form-item>
        </el-form>
        <footer>
          <el-button size="small" @click="close('rechargeForm')">取消</el-button>
          <el-button size="small" type="primary" @click="submitForm('rechargeForm')"
            >确认</el-button
          >
        </footer>
      </div>
    </div>

    <el-dialog title="操作结果提示" :visible.sync="show2">
      <el-table :data="list" height="400px" row-key="userRandomId">
        <el-table-column type="index" label="编号" align="center" />
        <el-table-column label="用户ID" width="120" align="center" prop="userRandomId" />
        <el-table-column label="处理结果" align="center" prop="result" />
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      show: false, //短信验证
      show2: false, //操作结果
      userRandomIds: '', // 充豆用户ID
      form: {
        applicant: '', //申请人
        approver: '', //审批人
        chipType: 2, // 金豆类型
        rechargeChip: '', // 充豆金额
        rechargeStatus: 1, // 充豆状态
        rechargeType: 1, // 充豆类型
        replenishmentNo: '', // 补单订单号
        smsCode: '',
        remark: '',
      },
      rules: {
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      typeOptions: [
        { label: '可提金豆', value: '1' },
        { label: '不可提金豆', value: '2' },
      ],
      rechargeTypeOptions: [
        { label: '手工收费', value: 1 },
        { label: '手工扣豆', value: 2 },
        { label: '赠送', value: 3 },
        { label: '系统红包', value: 4 },
        { label: '手工补单', value: 5 },
        { label: '营销-牌桌金豆红包', value: 6 },
        { label: 'BUG赔付', value: 7 },
        { label: '手动提现 ', value: 8 },
        { label: 'T名单', value: 9 },
      ],
      rechargeStatusOptions: [
        { label: '已收', value: 1 },
        { label: '未收', value: 2 },
      ],
      chipTypeOptions: [
        { label: '可提金豆', value: 1 },
        { label: '不可提金豆', value: 2 },
      ],
      list: [], //操作结果
    };
  },
  computed: {
    rechargeStatusDisabled() {
      let arr = [1, 2, 8];
      return arr.indexOf(this.form.rechargeType) <= -1;
    },
  },
  methods: {
    ...mapActions('other', ['sendCodeToMyPhone']),
    ...mapActions('manualRechargeUserChip', ['doBatchManualRecharge']),
    rechargeTypeChange(value) {
      if (value === 8) {
        this.form.rechargeStatus = 3;
        this.rechargeStatusOptions = [
          { label: '已付', value: 3 },
          { label: '未付', value: 4 },
        ];
      } else {
        this.form.rechargeStatus = 1;
        this.rechargeStatusOptions = [
          { label: '已收', value: 1 },
          { label: '未收', value: 2 },
        ];
      }
    },
    showPopup() {
      if (!this.userRandomIds) {
        this.$message.info('请输入用户ID');
        return;
      }
      if (!this.form.rechargeChip) {
        this.$message.info('请输入充豆数量');
        return;
      }

      if (this.form.rechargeType === 2 || this.form.rechargeType === 8) {
        if (this.form.rechargeChip >= 0) {
          this.$message.error('手工扣豆的充豆数量应小于0');
          return;
        }
      } else {
        if (this.form.rechargeChip <= 0) {
          this.$message.error('充豆数量应大于0');
          return;
        }
      }
      if (this.form.rechargeChip >= 100000000) {
        this.$message.info('赠送数量超出范围');
        return;
      }
      this.show = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.form;
          params.userRandomIds = this.userRandomIds.split(',');
          params.rechargeChip = params.rechargeChip * 100;
          this.doBatchManualRecharge(params).then((res) => {
            this.list = res.data;
            this.show2 = true;
            this.close(formName);
            this.$emit('my-submit');
          });
        }
      });
    },
    close(formName) {
      this.$refs[formName].resetFields();
      this.show = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.table {
  :global(.el-textarea) {
    width: 220px;
  }
  :global(.el-input__inner) {
    width: 200px;
  }
  @media (min-width: 1450px) {
    :global(.el-textarea) {
      width: 280px;
    }
    :global(.el-input__inner) {
      width: 240px;
    }
  }
  @media (min-width: 1600px) {
    :global(.el-textarea) {
      width: 320px;
    }
    :global(.el-input__inner) {
      width: 280px;
    }
  }
}
</style>
